const I18N = {
  en: {
    pageTitle: "AlterTable - Online SQL Schema Diff & Alter Generator",
    title: "AlterTable",
    subtitle: "SQL Schema Diff",
    labelLocal: "Local Schema (New)",
    labelProd: "Prod Schema (Current)",
    options: "Diff Options",
    run: "Generate Diff",
    sql: "Safe ALTER SQL",
    diff: "Diff Result",
    ast: "AST Context",
    rollback: "Rollback SQL (Down)",
    optAddCol: "Allow ADD COLUMN",
    optAddIdx: "Allow ADD INDEX / UNIQUE",
    optDeny: "Deny DROP / RENAME",
    optCmpComm: "Compare COLUMN COMMENT",
    optRisk: "Enable Risk Analysis",
    optRollback: "Include Rollback SQL",
    optAst: "Show AST Diff",
    btnCopy: "COPY",
    btnDown: "DOWN",
    footerBrand: "AlterTable",
    footerDesc: "A professional toolkit designed for database engineers. We simplify the complex process of schema migration by generating precise, safe, and dependency-aware SQL scripts. Built with a focus on speed and local-first security.",
    footerSecurity: "100% Client-Side Processing",
    footerPrivacy: "Zero Data Transmission"
  },
  zh: {
    pageTitle: "AlterTable - 在线 SQL 表结构对比与安全 ALTER 生成",
    title: "AlterTable",
    subtitle: "SQL Schema Diff",
    labelLocal: "本地结构 (新版本)",
    labelProd: "生产结构 (旧版本)",
    options: "对比选项",
    run: "生成差异",
    sql: "安全 ALTER SQL",
    diff: "差异详情",
    ast: "AST 抽象语法树",
    rollback: "回滚脚本 (Down SQL)",
    optAddCol: "允许新增字段",
    optAddIdx: "允许新增索引/唯一键",
    optDeny: "禁止删除/重命名",
    optCmpComm: "对比字段注释",
    optRisk: "启用风险分析",
    optRollback: "生成回滚 SQL",
    optAst: "显示 AST 差异",
    btnCopy: "复制",
    btnDown: "下载",
    footerBrand: "关于 AlterTable",
    footerDesc: "这是一款专为数据库工程师打造的高效迁移工具。我们通过智能的依赖分析与风险评估，将复杂的表结构对比简化为精准、安全的可执行脚本。工具坚持“本地优先”原则，确保您的核心架构数据绝不外传。",
    footerSecurity: "全量数据本地处理",
    footerPrivacy: "无服务器端数据留存"
  }
};

let lang = localStorage.lang || ((navigator.language || '').startsWith('zh') ? 'zh' : 'en');

function initLang() {
  const langSwitch = document.getElementById('langSwitch');
  if (!langSwitch) return;
  langSwitch.innerHTML = '<option value="en">English</option><option value="zh">简体中文</option>';
  langSwitch.value = lang;
  applyLang();
}

function applyLang() {
  const current = I18N[lang];
  if (!current) return;
  document.title = current.pageTitle;
  const mapping = {
    'brandTitle': 'title',
    'brandSubtitle': 'subtitle',
    'labelLocal': 'labelLocal',
    'labelProd': 'labelProd',
    'optionsTitle': 'options',
    'runBtn': 'run',
    'sqlTitle': 'sql',
    'diffTitle': 'diff',
    'astTitle': 'ast',
    'rollbackTitle': 'rollback',
    'labelOptAddCol': 'optAddCol',
    'labelOptAddIdx': 'optAddIdx',
    'labelOptDeny': 'optDeny',
    'labelOptCmpComm': 'optCmpComm',
    'labelOptRisk': 'optRisk',
    'labelOptRollback': 'optRollback',
    'labelOptAst': 'optAst',
    'footerBrand': 'footerBrand',
    'footerDesc': 'footerDesc',
    'footerSecurity': 'footerSecurity',
    'footerPrivacy': 'footerPrivacy'
  };
  Object.keys(mapping).forEach(id => {
    const el = document.getElementById(id);
    if (el) el.innerText = current[mapping[id]] || '';
  });
  document.querySelectorAll('.btn-i18n-copy').forEach(el => el.innerText = current.btnCopy);
  document.querySelectorAll('.btn-i18n-down').forEach(el => el.innerText = current.btnDown);
}

export function setupI18n() {
  initLang();
  const langSwitch = document.getElementById('langSwitch');
  if (langSwitch) {
    langSwitch.onchange = () => {
      lang = langSwitch.value;
      localStorage.lang = lang;
      applyLang();
    };
  }
}
export { lang };
